'use client'

import MyAccountContainer from 'pageContainers/MyAccount'

export default function MyAccount() {
  return <MyAccountContainer />
}
